import React from 'react';
import Api from "../services/Api";
import LogoTC from "../images/Logo TC Transport.jpeg";
import "../css/main.css";
import "../css/util.css";
import axios from 'axios';
import Swal from 'sweetalert2';

class Login extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			usuario: "",
			password: "",
			errores: []
		}
	}
	cambioValor = (e) => {
		const state = this.state;
		state[e.target.name] = e.target.value;
		this.setState({ state, errores: [] })
	}
	verificarError(elemento) {
		return this.state.errores.indexOf(elemento) !== -1;
	}
	enviarDatos = (e) => {
		e.preventDefault();
		Swal.showLoading();
		const { usuario, password } = this.state;
		var errores = [];
		if (!usuario) {
			errores.push("error_usuario");
		}
		if (!password) {
			errores.push("error_password");
		}
		this.setState({ errores: errores });
		if (errores.length > 0) {
			return false;
		}
		var datosEnviar = { email: usuario, password: password }
		//console.log(JSON.stringify(datosEnviar));
		axios
			.post(Api + "auth/login", datosEnviar, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				}
			})
			.then(
				(response) => {
					console.log(response.data)
					if (response.data.State) {
						window.localStorage.setItem('id_rol', response.data.datos.id_rol)
						window.localStorage.setItem('username', response.data.datos.email);
						window.localStorage.setItem('nombre', response.data.datos.nombre);
						window.localStorage.setItem('idusuario', response.data.datos.id);
						window.localStorage.setItem('id_cod_dpto', response.data.datos.id_cod_dpto);
						window.localStorage.setItem('id_cod_mpio', response.data.datos.id_cod_mpio);
						window.localStorage.setItem('token', response.data.token);
						window.location.href = '/';
					} else {
						alert(response.data.error);
						Swal.close();
					}
				},
				(error) => {
					Swal.fire('Email o contraseña invalida', '', 'error');
					Swal.close();
				}
			);
	}
	componentDidMount() {
		document.getElementById('usuario').focus();
	}
	render() {
		const { usuario, password } = this.state
		return (
			<div className="limiter">
				<div className="container-login100">
					<div className="wrap-login100">
						<form onSubmit={this.enviarDatos} className="login100-form validate-form">
							<span style={{ paddingBottom: 0 }} className="login100-form-title p-b-34">
								<h1>
									<b>Welcome</b>
								</h1>
								<img style={{ marginBottom: '10px' }} src={LogoTC} alt='' className='imgglobal' />
								<br />
							</span>
							<div className="input-group mb-3">
								<div className="input-group-append">
									<div className="input-group-text">
										<span className="fas fa-user" />
									</div>
								</div>
								<input className={((this.verificarError("error_usuario")) ? "is-invalid" : "") + " form-control"} type="text" name="usuario" id="usuario" placeholder="USER" aria-describedby="helpId" onChange={this.cambioValor} />
								<small id="helpId" className="invalid-feedback">Type the User</small>
							</div>
							<div className="input-group mb-3">
								<div className="input-group-append">
									<div className="input-group-text">
										<span className="fas fa-lock" />
									</div>
								</div>
								<input className={((this.verificarError("error_password")) ? "is-invalid" : "") + " form-control"} type="password" name="password" id="password" placeholder="PASSWORD" aria-describedby="helpId" onChange={this.cambioValor} />
								<small id="helpId" className="invalid-feedback">Type the Password</small>
							</div>
							<div className="container-login100-form-btn">
								<button type='submit' className='btn btn-primary btn-block'>Log In</button>
							</div>
						</form>
						<div className="login100-more"></div>
					</div>
				</div>
			</div>
		);
	}
}
export default Login;